import classNames from 'classnames'

import photoInfra from '@web/libs/media/photoInfra'
import { ThumbnailType } from '@web/libs/media/photoInfra.constant'

import styles from './ThumbnailContent.module.scss'

interface Props {
  images: string[]
  thumbnailType: ThumbnailType
  isPaused: boolean
}

export const RollingImage = ({ images, thumbnailType, isPaused }: Props) => {
  return (
    <div style={{ height: '192px', position: 'relative' }}>
      {images.map((imageUrl, index) => (
        <div
          key={index}
          className={classNames(styles[`rolling${index + 1}`])}
          style={{
            backgroundImage: `url(${photoInfra.convertThumbnail({
              url: imageUrl,
              type: thumbnailType,
            })})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            borderRadius: '12px',
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            animationPlayState: isPaused ? 'paused' : 'running',
          }}
        />
      ))}
    </div>
  )
}
